// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ORHbV","notes":"Notes_notes__1uBhj","note":"Notes_note__1-ebU","markdown":"Notes_markdown__3oiC2"};